import {
  GET_PRODUCT_INFO,
  CREATE_BASIC_PRODUCT_INFO,
  UPDATE_BASIC_PRODUCT_INFO,
  DELETE_BASIC_PRODUCT_INFO,
  CREATE_ADMIN_PRODUCT_INFO,
  UPDATE_ADMIN_PRODUCT_INFO,
  DELETE_ADMIN_PRODUCT_INFO,
  GET_ALL_SEARCH,
} from '../../types'

const INITIAL_STATE = {
  allProducts: [],
  allStudy: [],
  oneStudy: {},
}

const basicProductReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_SEARCH:
      return {
        ...state,
        allStudy: payload.data,
      }
    case GET_PRODUCT_INFO:
      return {
        ...state,
        allProducts: payload,
      }
    case CREATE_BASIC_PRODUCT_INFO:
      return {
        ...state,
        allProducts: payload,
      }
    case UPDATE_BASIC_PRODUCT_INFO:
      return {
        ...state,
      }
    case DELETE_BASIC_PRODUCT_INFO:
      return {
        ...state,
      }
    case CREATE_ADMIN_PRODUCT_INFO:
      return {
        ...state,
        allProducts: payload,
      }
    case UPDATE_ADMIN_PRODUCT_INFO:
      return {
        ...state,
      }
    case DELETE_ADMIN_PRODUCT_INFO:
      return {
        ...state,
      }
    default:
      return state
  }
}

export default basicProductReducer
